import {Injectable} from '@angular/core';
import {BaseService} from "../../services/_base.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import {UserService} from "../../services/user.service";
import { ICRUDService } from '../../shared/crud-manager/crud.interface';
import { rxResource } from '@angular/core/rxjs-interop';
import { map, Observable, tap } from 'rxjs';
import { Brand } from '../../models/types';

@Injectable({
  providedIn: "root"
})
export class BrandsService extends BaseService implements ICRUDService{
  params = ['name']
  model = 'Brand';

  brands = rxResource({
    stream: () => this.all().pipe(map(res => res.body)),
  });

  constructor(public http:HttpClient,userService: UserService) {
    super();
  }
  index(value = null,page = 1){
    return this.http.get(this.adminURL+'/brands',this.getParams({search: value, page: page}));
  }

  all(): Observable<HttpResponse<Brand[]>> {
    return this.http.get<Brand[]>(this.adminURL+'/brands/all', this.getParams());
  } 

  create(value){
    return this.http.post(this.adminURL+'/brands/',{
      brand: this.permitParams(value,...this.params)
    },this.getParams()).pipe(
      tap(() => this.brands.reload()),
    );
  }
  update(id,value){
    return this.http.put(this.adminURL+'/brands/'+id,{
      brand: this.permitParams(value,...this.params)
    },this.getParams()).pipe(
      tap(() => this.brands.reload()),
    );
  }
  destroy(id){
    return this.http.delete(this.adminURL+'/brands/'+id,this.getParams()).pipe(
      tap(() => this.brands.reload()),
    );
  }
  restore(id){
    return this.http.delete(this.adminURL+'/brands/'+id+'/restore',this.getParams()).pipe(
      tap(() => this.brands.reload()),
    );
  }
  import(items=null){
    return this.http.post(this.adminURL+'/brands/import',{items: items},this.getParams()).pipe(
      tap(() => this.brands.reload()),
    );
  }
}
